/*
  ecw-offers.js: the browser half of "live" for promotion records (Platform brief, 18 Oct 2026).
  Liquid's current time is cached by Shopify's page cache, so a page can still print an offer after it ends.
  Every offer element carries data-ecw-starts and data-ecw-ends (ISO times, snippet ecw-offer-attrs); this script
  hides an element outside that window on load, and on elements added later (filters, quick add).
  It also serves the live records to the Alpine-rendered cards (window.ecwOffers.forProduct).
  It never changes a price: checkout is the price of record.
*/
(function () {
  function toTime(value) {
    if (!value) return NaN;
    /* accept +0100 as well as +01:00, which Safari needs */
    return Date.parse(String(value).replace(/([+-]\d\d)(\d\d)$/, '$1:$2'));
  }

  /* An unreadable time leaves the decision to Liquid's filter. */
  function liveAt(starts, ends, now) {
    var start = toTime(starts);
    if (!isNaN(start) && start > now) return false;
    if (!ends) return true;
    var end = toTime(ends);
    return isNaN(end) || end > now;
  }

  function isOn(el) {
    return liveAt(el.getAttribute('data-ecw-starts'), el.getAttribute('data-ecw-ends'), Date.now());
  }

  function hide(el) {
    if (isOn(el)) return;
    el.style.setProperty('display', 'none', 'important');
    el.setAttribute('data-ecw-off', '');
  }

  function apply(root) {
    root = root || document;
    if (root.matches && root.matches('[data-ecw-starts]')) hide(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-ecw-starts]').forEach(hide);
  }

  var records = null;
  function load() {
    if (records) return records;
    try {
      var node = document.getElementById('ecw-offers-data');
      records = node ? JSON.parse(node.textContent) : [];
    } catch (e) {
      records = [];
    }
    return records;
  }

  /* Live records naming a product, for cards rendered by Alpine from product JSON (item.id). */
  function forProduct(item) {
    if (!item || !item.id) return [];
    var id = Number(item.id);
    var now = Date.now();
    return load().filter(function (record) {
      return record.products.indexOf(id) > -1 && liveAt(record.starts, record.ends, now);
    });
  }

  window.ecwOffers = { liveAt: liveAt, isOn: isOn, apply: apply, forProduct: forProduct };

  apply(document);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) apply(document);
  });
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) apply(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
